const cropText = (text: string, count: number) => `${text.substring(0, count)} ${text.length > count ? '...' : ''}`;

export const safeString = (str: string | null | undefined) => str || '';

const stringUtil = { cropText };

export default stringUtil;
